<!-- =========================================================================================
  File Name: EditProfileSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} PROFILE</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <template >
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img v-if="ImgName"  :src="img_cdn+ImgName" class="responsive">
          </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click="ImgName = null">Remove Image</vs-button>
          </div>
        </template>

        <!-- Username-->
        <vs-input label="Username" v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" name="Username"
                  v-validate="'alpha_num|required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>


        <!-- FIRST NAME -->
        <vs-input label="First Name" v-model="dataFirstName" class="mt-5 w-full" name="First Name"
                  v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>

        <!-- Middle NAME -->
        <vs-input label="Middle Name" v-model="dataMiddleName" class="mt-5 w-full" name="item-middle-name"/>


        <!-- LAST NAME -->
        <vs-input label="Last Name" v-model="dataLastName" class="mt-5 w-full" name="Last Name"
                  v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>

        <!-- NICK NAME -->
        <vs-input label="Nickname" v-model="dataNickName" class="mt-5 w-full" name="Nick Name" />


        <!-- PHONE -->
        <vs-input label="Phone" v-model="dataPhone" @input="acceptNumber" class="mt-5 w-full" name="Phone"
                  v-validate="'required'"/>
        <br>
        <span class="text-danger text-sm" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</span>
        <!-- EMERGENCY CONTACT -->
        <!--        <vs-input label="Emergency contact" v-model="dataEmergencyContact" class="mt-5 w-full" name="item-last-name" /><br>-->


      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from "vue-select";
import {
  CHECK_USER_NAME_EXCEPT_ID,
  SINGLE_USER_BY_USERNAME,
  UPDATE_USER_ACTIVITY,
  UPDATE_USER_PROFILE,
  UPLOAD_IMAGE
} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data() {
    return {

      dataId: null,
      dataUserName: '',
      UserDuplicate:0,
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataNickName: '',
      dataImg: '',
      ImgName:null,
      img_cdn:'',
      oldimage:'',
      dataImgUrl: '',
      dataPhone: '',
      lang:process.env.VUE_APP_I18N_LOCALE,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const {id, username, fname, lname, middle_name, nick_name, phone, avatar,} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataUserName = username
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataNickName = nick_name
        this.ImgName = avatar
        this.oldimage = avatar
        this.dataPhone = phone
        this.enableInvitOption = false
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataUserName && this.dataFirstName && this.dataLastName && this.UserDuplicate===0
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    checkUserName() {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkUserNameExcepteId();
      } else {
        this.checkUserNameWithoutId()
      }
    },
    checkUserNameExcepteId() {
      var letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else {
        if (this.dataUserName) {
          this.$apollo
            .mutate({
              mutation: CHECK_USER_NAME_EXCEPT_ID,
              variables: {
                id: this.dataId,
                username: this.dataUserName,
              },
            })
            .then(response => {
              this.UserDuplicate=response.data.checkUserNameExceptId.length
            })
        }
      }
    },
    checkUserNameWithoutId() {
      var letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else {
        if (this.dataUserName) {
          this.$apollo
            .mutate({
              mutation: SINGLE_USER_BY_USERNAME,
              variables: {
                username: this.dataUserName,
              },
            })
            .then(response => {
              this.UserDuplicate=response.data.userByUserName.length
            })
        }
      }
    },
    StatusSuccess() {
      this.$vs.notify({
        title: "User",
        text: 'User Added Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusFail() {
      this.$vs.notify({
        title: "User",
        text: 'Failed to add User!',
        color: 'danger',
        position: 'top-right'
      })
    },
    AlreadyTaken() {
      this.$vs.notify({
        title: "Username",
        text: 'Username" Already Taken!',
        color: 'danger',
        position: 'top-right'
      })

    },
    UpdateSuccess() {
      this.$vs.notify({
        title: "User",
        text: 'User Update Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },

    acceptNumber() {
      let x = this.dataPhone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

      this.dataPhone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    initValues() {
      if (this.data.id) return
      this.dataId = null
      this.dataUserName = ''
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataMiddleName = ''
      this.dataNickName = ''
      this.dataImg = null
      this.dataPhone = ''
      this.ImgName = null
      this.oldimage = ''


    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_USER_PROFILE,
                variables: {
                  id: this.dataId,
                  username: this.dataUserName,
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  nick_name: this.dataNickName,
                  phone: this.dataPhone,
                  avatar: this.ImgName,

                }
              })
              .then(response => {
                if (response.data.updateUserProfile.status=='SUCCESS') {
                  if (response.data.updateUserProfile.user.avatar !== null) {
                    localStorage.setItem('userImage', response.data.updateUserProfile.user.avatar)
                  } else {
                    localStorage.removeItem('userImage')
                  }
                  localStorage.setItem('userName', response.data.updateUserProfile.user.fname + ' ' + response.data.updateUserProfile.user.lname)

                  this.UpdateSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()
                  if (this.lang=='dogs'){
                    window.location='/contact-profile'
                  }
                  else {
                    window.location='/user-profile'

                  }
                }
                else if (response.data.updateUserProfile.status=='ALREADY_TAKEN')
                  {
                    this.AlreadyTaken()
                }
              }).catch(error => {
              console.log(error)
            });
          }


        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image:this.dataImg,
                oldimage:this.oldimage,
              }
            })
            .then(response => {
              if (response){
                this.oldimage=''
                if(response.data.uploadImage.status=="SUCCESS"){
                  this.ImgName = response.data.uploadImage.image_name
                  this.UpadateuserActivity()
                }
                else{
                  this.ImgName = response.data.uploadImage.image_name
                  this.UploadFail(response.data.uploadImage.error)
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }

              }
            }) .catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  UpadateuserActivity () {

    if (this.dataId !== null && this.dataId >= 0) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: this.dataId,
            object_type:"App\\Models\\User",
            activity:"updated"
          }
        })
    }
  },
  created() {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
